function setupAvatarPreviews() {
  const inputs = Array.from(document.querySelectorAll('[id^="avatar_input_"]'))
  const previews = Array.from(document.querySelectorAll('[id^="avatar_preview_"]'))

  // Include the new guest elements
  const newInput = document.querySelector('[id^="avatar_input_new_guest"]')
  const newPreview = document.querySelector('[id^="avatar_preview_new_guest"]')
  if (newInput) inputs.push(newInput)
  if (newPreview) previews.push(newPreview)

  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i]
    const preview = previews[i]

    if (!input || !preview) continue

    input.addEventListener('change', function (event) {
      const file = event.target.files[0]

      // Hide any old image preview (if still present somewhere)
      const currentImage = document.querySelector('[id^="avatar_preview_current_"]')
      if (currentImage) {
        currentImage.style.display = 'none'
      }

      if (file && file.type.startsWith('image/') && !preview.id.includes('avatar_preview_current_')) {
        const reader = new FileReader()
        reader.onload = function (e) {
          preview.src = e.target.result
          preview.style.display = 'block'
        }
        reader.readAsDataURL(file)
      } else {
        preview.src = ''
        preview.style.display = 'none'
      }
    })
  }
}

document.addEventListener('turbo:load', setupAvatarPreviews)
document.addEventListener('turbo:frame-load', setupAvatarPreviews)